import React, { useEffect, useRef, useState } from "react";

import { card1Svg, card2Svg, card3Svg, card4Svg, coin } from "./svg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const cards = [
  { 
    url: "https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1740640252841_animationCard1",
    icon: card1Svg,
    title: "Refer your <br /> Friends",
    subTitle: "Get 200 Pts Instantly",
    cta: "Refer Now",
    path: "/gift-and-earn"
  },
  { 
    url: "https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1740641319378_animationCard2",
    icon: card2Svg,
    title: "Redeem Points  <br /> on Deals",
    subTitle: "Get 200 Pts Instantly",
    cta: "Redeem Now",
    path: "/deals"
  },
  { 
    url: "https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1740641403295_animationCard3",
    icon: card3Svg,
    title: "Complete your <br /> Profile",
    subTitle: "Get 100 Pts Instantly",
    cta: "Complete Now",
    path: "/myprofile/info"
  },
  { 
    url: "https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1740641449253_animationCard4",
    icon: card4Svg,
    title: "Give <br /> Feedback",
    subTitle: "Get 100 Pts Instantly",
    cta: "Give Feedback",
    path: "/contact-us"
  }
];

const RewardsGuide = () => {
    const history=useHistory();
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
 

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            setIsVisible(true);
          }, 500);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div ref={sectionRef} className="bg-[#F0F0F0] w-full py-10 flex flex-col items-center">
      {/* Section Title */}
      <div className="text-center mb-6">
        <div className="flex items-center justify-center gap-2">
          <div className="w-16 h-[2px] bg-gray-400"></div>
          <p className="text-lg font-semibold text-gray-700">How to Earn More Coins</p>
          <div className="w-16 h-[2px] bg-gray-400"></div>
        </div>
        <div className="flex justify-center mt-2">{coin}</div>
      </div>

      {/* <div 
      className="w-full lg:overflow-x-auto lg:no-scrollbar lg:px-6 mt-4 lg:scrollbar-thin 2xl:flex 2xl:justify-center"
      >
        <div className="grid grid-cols-2 gap-2 md:gap-5 lg:flex lg:flex-nowrap w-max my-2"> */}
        <div className="w-full flex justify-center lg:justify-start xl:justify-center lg:overflow-x-auto lg:no-scrollbar lg:px-6 mt-4 lg:scrollbar-thin">
  <div className="grid grid-cols-2 gap-2 md:gap-5 lg:flex lg:flex-nowrap  w-max my-2">


          {cards.map((card, index) => (
            <div
              key={index}
              className="w-[170px] h-[277px] md:w-[280px] md:h-[400px] bg-cover bg-center flex flex-col justify-start items-center p-4 rounded-2xl shadow-lg text-white"
              style={{ backgroundImage: `url(${card.url})` }}
            >
              <div
                className={`flex items-center mt-2 lg:mb-4 md:mt-4 w-[75px] h-[75px] md:w-[95px] md:h-[95px] transform transition-opacity duration-500 ${
                  isVisible ? "opacity-100 animate-fadeIn animate-shake" : "opacity-0"
                }`}
              >
                {card.icon}
              </div>

              <h2
                className="text-[14px] md:text-base font-semibold text-center mt-4"
                dangerouslySetInnerHTML={{ __html: card.title }}
              ></h2>

              <p className="text-[18px] md:text-[24px] font-bold mt-1 text-center">
                {card.subTitle.split(" ").slice(0, 3).join(" ")}
                <br />
                <span className="font-semibold text-base">
                  {card.subTitle.split(" ").slice(3).join(" ")}
                </span>
              </p>

              {/* CTA Button */}
              <button
                className="mt-2 bg-white text-black py-2 px-4 rounded-lg mb-6"
                onClick={() => history.push(card.path)} // Navigate on button click
              >
                {card.cta}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RewardsGuide;
